
import { Component, Mixins } from "vue-property-decorator";
import { IDateDurationExpressionBehavior, DateDurationKinds } from "../../../../../../documaker/domain/format/objects";
import { IDateDurationExpressionBehaviorPropertyEditable, instanceOfIDateDurationExpressionBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class DateDurationExpressionBehaviorPropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: IDateDurationExpressionBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IDateDurationExpressionBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isDateDurationExpressionBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIDateDurationExpressionBehaviorPropertyEditable(s) && s.dateDurationExpressionBehavior().isEditable(), false);
  }

  get dateDurationExpressionBehavior(): IDateDurationExpressionBehavior {
    return this.readPropertyOrDefault(s => s.dateDurationExpressionBehavior().getValue(), { kind: DateDurationKinds.Days, isContainedFrom: true , from: null, to: null });
  }

  set dateDurationExpressionBehavior(value: IDateDurationExpressionBehavior) {
    this.writePropertyWhenValid(s => s.dateDurationExpressionBehavior().setValue(value));
  }
}
